import * as type from '../../../actions/index.types';

const initialState = {
    employeesListLoading: false,
    employeesListData: null,
    employeesPagination: null,

    employeeDetailsLoading: false,
    employeeDetailsData: null,

    createEmployeeLoading: false,
    updateEmployeeLoading: false,
    deleteEmployeeLoading: false,

    employeeTypesLoading: false,
    employeeTypesData: null,

    countriesDropdownLoading: false,
    countriesDropdownData: null,

    employeeAuditLogLoading: false,
    employeeAuditLogData: null,

    searchedEmployeeLoading: false,
    searchedEmployeeData: null,
    searchedEmployeeError: null,

    linkEmployeeLoading: false,

    usernamesDropdownLoading: false,
    usernamesDropdownData: null,

    employeesDropdownLoading: false,
    employeesDropdownData: null,


    error: null,
};

export function EmployeeReducer(state = initialState, action) {
    switch (action.type) {
        case type.SOCIETY_GET_EMPLOYEES_LIST:
            return { ...state, employeesListLoading: true, error: null };
        case type.SOCIETY_GET_EMPLOYEES_LIST_SUCCESS: {
            const meta = action.payload?.pagination;
            const fallbackCount = action.payload?.count ?? action.payload?.total ?? 0;
            return {
                ...state,
                employeesListLoading: false,
                employeesListData: action.payload?.rows || action.payload?.employees || action.payload?.data || action.payload || [],
                employeesPagination: meta || {
                    total: fallbackCount,
                    totalPages: Math.ceil(fallbackCount / 10),
                },
                error: null,
            };
        }
        case type.SOCIETY_GET_EMPLOYEES_LIST_FAILURE:
            return { ...state, employeesListLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_GET_EMPLOYEE_DETAILS:
            return { ...state, employeeDetailsLoading: true, error: null };
        case type.SOCIETY_GET_EMPLOYEE_DETAILS_SUCCESS:
            return { ...state, employeeDetailsLoading: false, employeeDetailsData: action.payload, error: null };
        case type.SOCIETY_GET_EMPLOYEE_DETAILS_FAILURE:
            return { ...state, employeeDetailsLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_CREATE_EMPLOYEE:
            return { ...state, createEmployeeLoading: true, error: null };
        case type.SOCIETY_CREATE_EMPLOYEE_SUCCESS:
            return { ...state, createEmployeeLoading: false, error: null };
        case type.SOCIETY_CREATE_EMPLOYEE_FAILURE:
            return { ...state, createEmployeeLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_UPDATE_EMPLOYEE:
            return { ...state, updateEmployeeLoading: true, error: null };
        case type.SOCIETY_UPDATE_EMPLOYEE_SUCCESS:
            return { ...state, updateEmployeeLoading: false, error: null };
        case type.SOCIETY_UPDATE_EMPLOYEE_FAILURE:
            return { ...state, updateEmployeeLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_DELETE_EMPLOYEE:
            return { ...state, deleteEmployeeLoading: true, error: null };
        case type.SOCIETY_DELETE_EMPLOYEE_SUCCESS:
            return { ...state, deleteEmployeeLoading: false, error: null };
        case type.SOCIETY_DELETE_EMPLOYEE_FAILURE:
            return { ...state, deleteEmployeeLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_GET_EMPLOYEE_TYPES:
            return { ...state, employeeTypesLoading: true, error: null };
        case type.SOCIETY_GET_EMPLOYEE_TYPES_SUCCESS:
            return {
                ...state,
                employeeTypesLoading: false,
                employeeTypesData: action.payload?.rows || action.payload?.types || action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_EMPLOYEE_TYPES_FAILURE:
            return { ...state, employeeTypesLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_GET_COUNTRIES_DROPDOWN:
            return { ...state, countriesDropdownLoading: true, error: null };
        case type.SOCIETY_GET_COUNTRIES_DROPDOWN_SUCCESS:
            return {
                ...state,
                countriesDropdownLoading: false,
                countriesDropdownData: action.payload?.rows || action.payload?.countries || action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_COUNTRIES_DROPDOWN_FAILURE:
            return { ...state, countriesDropdownLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_GET_EMPLOYEE_AUDIT_LOG:
            return { ...state, employeeAuditLogLoading: true, employeeAuditLogData: null, error: null };
        case type.SOCIETY_GET_EMPLOYEE_AUDIT_LOG_SUCCESS:
            return {
                ...state,
                employeeAuditLogLoading: false,
                employeeAuditLogData: action.payload?.rows || action.payload?.logs || action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_EMPLOYEE_AUDIT_LOG_FAILURE:
            return { ...state, employeeAuditLogLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL:
            return { ...state, searchedEmployeeLoading: true, searchedEmployeeData: null, searchedEmployeeError: null };
        case type.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS:
            return {
                ...state,
                searchedEmployeeLoading: false,
                searchedEmployeeData: action.payload?.data || action.payload || null,
                searchedEmployeeError: null,
            };
        case type.SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE:
            return {
                ...state,
                searchedEmployeeLoading: false,
                searchedEmployeeData: null,
                searchedEmployeeError: action?.message || 'Employee not found',
            };
        case type.SOCIETY_CLEAR_EMPLOYEE_SEARCH:
            return { ...state, searchedEmployeeData: null, searchedEmployeeError: null, searchedEmployeeLoading: false };

        case type.SOCIETY_LINK_EXISTING_EMPLOYEE:
            return { ...state, linkEmployeeLoading: true, error: null };
        case type.SOCIETY_LINK_EXISTING_EMPLOYEE_SUCCESS:
            return { ...state, linkEmployeeLoading: false };
        case type.SOCIETY_LINK_EXISTING_EMPLOYEE_FAILURE:
            return { ...state, linkEmployeeLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_GET_USERNAMES_DROPDOWN:
            return { ...state, usernamesDropdownLoading: true, error: null };
        case type.SOCIETY_GET_USERNAMES_DROPDOWN_SUCCESS:
            return {
                ...state,
                usernamesDropdownLoading: false,
                usernamesDropdownData: action.payload?.rows || action.payload?.users || action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_USERNAMES_DROPDOWN_FAILURE:
            return { ...state, usernamesDropdownLoading: false, error: action?.message || 'Something went wrong.' };

        case type.SOCIETY_GET_EMPLOYEES_DROPDOWN:
            return { ...state, employeesDropdownLoading: true, error: null };
        case type.SOCIETY_GET_EMPLOYEES_DROPDOWN_SUCCESS:
            return {
                ...state,
                employeesDropdownLoading: false,
                employeesDropdownData: action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_EMPLOYEES_DROPDOWN_FAILURE:
            return { ...state, employeesDropdownLoading: false, error: action?.message || 'Something went wrong.' };

        default:
            return state;
    }
}
